var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.component,{tag:"component",attrs:{"value":_vm.items},on:{"input":function($event){_vm.$emit('input',$event)}}},[_vm._l((_vm.items),function(item,index){return [_vm._t("default",null,{item:item,itemIndex:index})]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }